<template>
    <div class="col-12 col-md-6 mb-3 card-wrap" @click.prevent="renderModal()" :data-topics="topics" :data-cancer-types="cancer_types">
        <div class="card p-4 h-100 card-videos bg-white">
            <div class="aspect-ratio-box aspect-ratio-box-16x9 patient-education-video-thumbnail">
                <img :src="featured_img" alt="alt_text" class="aspect-ratio-box-inner object-fit-cover object-position-center-center"/>
            </div>
            <div class="card-body px-0 py-0 mt-2">
                <strong v-if="title" class="card-title mb-0 d-block h6">{{ title }}</strong>
                <div v-if="description" class="card-text">{{ description }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Helpers from "../../scripts/helpers"

export default {
    props: ['patient_education_video'],
    data(){
        return{
            topics: '',
            cancer_types: '',
            video: '',
            description: '',
            title: '',
            id: '',
            youtube_id: ''
        }
    },
    computed: {
        featured_img() {
            return this.youtube_id ? "https://img.youtube.com/vi/" + this.youtube_id + "/hqdefault.jpg" : null;
        },
        alt_text() {
            return this.title;
        },
        video_embed() {
            return this.video ? this.video : `<div class="patient_education_video_embed"><div class="aspect-ratio-box aspect-ratio-box-16x9"><iframe class="aspect-ratio-box-inner" src=\"https://www.youtube.com/embed/${ this.youtube_id }\" title=\"Video embed - ${ this.title  }\" width="800" height="450"></iframe></div></div>`
        }
    },
    methods: {
        renderPost(){
            this.id = this.$props.patient_education_video['id']
            this.title = this.$props.patient_education_video['title']
            this.featured_img = this.$props.patient_education_video['featured_img']
            this.description = Helpers.decodeHTMLEntities(this.$props.patient_education_video['description'])
            this.video = this.$props.patient_education_video['video_embed']
            this.topics = this.$props.patient_education_video['topics']
            this.cancer_types = this.$props.patient_education_video['cancer_types']
            this.youtube_id = this.$props.patient_education_video['youtube_id']
        },
        renderModal(){
            let modal = document.querySelector('.modal-wrap')
            modal.classList.add('active')
            let modalBody = modal.querySelector('.modal-body')
            modalBody.innerHTML = this.video_embed
        }
    },
    mounted(){
        this.renderPost()
    }
}
</script>